import React from "react";
import "./Styles/TeamsPeople.css"; // Import the CSS for styling

function TeamsPeople() {
    return (
        <div className="teams-page">
            <h1>Teams and People</h1>
            <div className="diagram">
                <div className="circle">
                    <p>Robots fighting in a ring concept</p>
                </div>
                <div className="description mechanical">Mechanical team description</div>
                <div className="description electrical">Elec team description</div>
                <div className="description software">Soft team description</div>
            </div>
            <p className="footer-text">
                Instead of robots fighting in a ring concept, we can do something with our logo in the center or we can use a tree figure to show a tree as DCRT and branches as teams.
            </p>
        </div>
    );
}

export default TeamsPeople;
